import { getReturnURL } from '../../../domain/url-provider';
import { Popup } from '../../../ui/popup/popup';
import { useEffect } from 'react';
import { sendGAEvent } from '../../../domain/marketing/gtm-provider';

/**
 * Login popup in 'my recommended' page.
 */
export const MyRecommendedLoginPopup = () => {

    useEffect(() => {
        sendGAEvent('My Recommended Products Page','Login Popup');
    }, []);

    return (
        <Popup width="400px" height="370px" canBeClosed={ false } styles={{
            padding: 0,
        }}>
            <div className="flex flex-col items-center w-full h-full text-center">
                <div className="bg-blue-200 w-full flex flex-col justify-center items-center p-4 mb-4">
                    <p className="mb-4">
                        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 79.3 82.3" xmlSpace="preserve" width={50} height={52}><g fill="#FFF"><path d="M5 28.3c-2.8 0-5 2.2-5 5v43.8c0 2.8 2.2 5 5 5h14.5c2.6 0 4.8-2 5-4.7l3.1 1.9c3 1.8 6.3 2.7 9.8 2.7h21.1c2.6 0 5.1-.5 7.4-1.5 6.8-3 7.8-8.3 7.3-11.8 3.6-3 4.9-7.9 3.2-12.2 1.7-2 2.6-4.6 2.5-7.2-.1-2.1-.8-4-2.1-5.7 1.6-3.6.7-7.8-2.3-10.5-.2-.2-.4-.4-.7-.5-1.1-.8-2.4-1.4-3.8-1.7-6.6-1.4-11.1-1.5-17.6-1.5-.2-1.5-.2-4.7 1.7-10.7 1.8-5.5 1.7-10.1-.5-13.6C51.8 2.3 48.8.4 45.5 0h-.3c-2.4 0-4.5 1.5-5.2 3.7 0 .1-.1.2-.1.4l-.8 5.4c-.2 1.6-.7 3.2-1.4 4.7l-7.3 15.3c-1.1 2.6-3.4 4.4-6.1 5v-1.2c0-2.8-2.2-5-5-5H5zm0 48.8V33.3h14.5v43.8H5zm20-37.6c4.5-.8 8.3-3.8 10.1-8l7.2-15.3c.9-1.9 1.5-4 1.8-6.1l.8-5c.1-.1.1-.1.2-.1 1.8.3 3.3 1.3 4.3 2.8 1.3 2.1 1.3 5.4 0 9.4-1.9 5.8-2.5 10.5-1.8 13.7.5 2.1 2.3 3.5 4.4 3.5 6.6 0 10.7.1 17 1.4h.1c.7.1 1.3.4 1.8.8l.3.3c2.6 2.3.9 5.3.6 5.8-.7 1-.5 2.4.4 3.2 1 1 1.6 2.3 1.7 3.7-.1 1.9-.9 3.6-2.2 4.9-.8.8-.9 2-.3 3 .1.2 2.7 4.7-2.4 8.4-.9.7-1.2 1.8-.9 2.8.3.8 1.3 4.9-4.2 7.3-1.7.7-3.6 1.1-5.5 1H37.3c-2.5 0-5-.7-7.2-2l-5.6-3.4v-32l.5-.1z"/><circle cx="12.2" cy="69.3" r="3.1"/></g></svg>
                    </p>

                    <p className="text-white text-lg">My Recommended Products</p>
                </div>

                <p className="m-4">These products are most frequently bought by
                    other users who own the same products as you.</p>

                <a className="w-btn" href={ getReturnURL() } title="LOG IN NOW" style={{ width: '170px' }}>Log In To View</a>

                <p className="mt-4">Want to view top-selling products instead?</p>
                <p><a href="/best-sellers">View our Best Sellers page</a></p>
            </div>
        </Popup>
    )
};